export default "__VITE_ASSET__102fbf8d__"